import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-00e13c8f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-global container-profile" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Perfil")
], -1))
const _hoisted_2 = { class: "card-global container-profile" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Suscripción", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "highlight-box" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Estás disfrutando de un mes gratis. ¡Aprovecha al máximo!")
], -1))
const _hoisted_5 = { class: "subscription-content" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"plans-container\" data-v-00e13c8f><div class=\"card-global plan-card\" data-v-00e13c8f><h2 data-v-00e13c8f>Plan Mensual</h2><p data-v-00e13c8f>$30.000 / mes</p><p class=\"highlight\" data-v-00e13c8f>¡1 mes gratis!</p><ul data-v-00e13c8f><li data-v-00e13c8f>Almacenamiento ilimitado</li><li data-v-00e13c8f>Acceso a gráficas</li><li data-v-00e13c8f>Acceso a historial</li><li data-v-00e13c8f>Calendario</li><li data-v-00e13c8f>Acceso a asistente virtual County</li><li data-v-00e13c8f>Integración con hojas de cálculo</li></ul></div><div class=\"card-global plan-card\" data-v-00e13c8f><h2 data-v-00e13c8f>Plan Anual</h2><p data-v-00e13c8f>$300.000 / año</p><p class=\"highlight\" data-v-00e13c8f>¡1 mes gratis y ahorra un 16%!</p><ul data-v-00e13c8f><li data-v-00e13c8f>Almacenamiento ilimitado</li><li data-v-00e13c8f>Acceso a gráficas</li><li data-v-00e13c8f>Acceso a historial</li><li data-v-00e13c8f>Calendario</li><li data-v-00e13c8f>Acceso a asistente virtual County</li><li data-v-00e13c8f>Integración con hojas de cálculo</li></ul></div></div>", 1)
const _hoisted_7 = { class: "mercado-pago-container" }

import MercadoPagoComponent from '@/components/MercadoPagoComponent.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileView',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(MercadoPagoComponent)
        ])
      ])
    ])
  ]))
}
}

})